import React, { useState, useEffect } from 'react';
import { showError, showSuccess } from '../utils/alerts';
import { crearAsiento, obtenerCuentas } from '../services/asientosService';
import AsientoLineasEditor, { entriesToPayload, sumaMontos } from './common/AsientoLineasEditor';
import '../styles/components/AsientosForm.css';

const AsientosForm = ({ token, id_company }) => {
    const [formData, setFormData] = useState({
        fecha: '',
        descripcion: ''
    });
    const [debeEntries, setDebeEntries] = useState([{ cuenta: '', monto: '' }]);
    const [haberEntries, setHaberEntries] = useState([{ cuenta: '', monto: '' }]);

    const [cuentas, setCuentas] = useState([]);

    useEffect(() => {
        const fetchCuentas = async () => {
            try {
                const data = await obtenerCuentas();
                setCuentas(data);
            } catch (error) {
                console.error('Error al obtener cuentas:', error);
            }
        };
        if (token) {
            fetchCuentas();
        }
    }, [token]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (sumaMontos(debeEntries) !== sumaMontos(haberEntries)) {
            showError('El asiento no está balanceado: la suma del Debe debe ser igual a la suma del Haber');
            return;
        }

        try {
            const payload = {
                ...formData,
                debeEntries: entriesToPayload(debeEntries),
                haberEntries: entriesToPayload(haberEntries),
                id_company
            };
            const data = await crearAsiento(payload);
            showSuccess(data);
            setFormData({ fecha: '', descripcion: '' });
            setDebeEntries([{ cuenta: '', monto: '' }]);
            setHaberEntries([{ cuenta: '', monto: '' }]);
        } catch (error) {
            console.error('Error al crear asiento contable:', error);
            showError(error.response?.data || 'Hubo un error al crear el asiento contable');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="asientos-form">
            <div className="input-icon">
                <input
                    type="text"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleChange}
                    placeholder="dd-mm-aaaa"
                    onFocus={(e) => (e.target.type = 'date')}
                    onBlur={(e) => {
                        if (e.target.value === '') e.target.type = 'text';
                    }}
                    required
                />
            </div>
            <AsientoLineasEditor
                cuentas={cuentas}
                debeEntries={debeEntries}
                haberEntries={haberEntries}
                onDebeEntriesChange={setDebeEntries}
                onHaberEntriesChange={setHaberEntries}
            />
            <input type="text" name="descripcion" value={formData.descripcion} onChange={handleChange} placeholder="Glosa" required />
            <button type="submit">Crear Asiento Contable</button>
        </form>
    );
};

export default AsientosForm;
